export enum InspectionTemplateStatus {
  draft = 'DRAFT',
  published = 'PUBLISHED',
}
